// extracted by mini-css-extract-plugin
export default {"container":"UnsavedInformationNotice_container__ChubN","important":"UnsavedInformationNotice_important__OO+KH"};